import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { PointManagementList, PointManagementEdit, PointManagementDetail } from './components';
import { PointManagementActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    },
})

const IdentitySelector = (state) => state.Identity;

const PointManagement = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const pointManagementActions = bindActionCreators(PointManagementActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { token } = useSelector(IdentitySelector);

    // 画面モードと併せて、一覧画面のフィルタリング情報も保持（加盟店名、加盟店タイプ、ポイント設定名、ポイント種別、適用区分）
    const [modeInfo, setModeInfo] = useState({ mode: 'list', merchant_name: '', merchant_type: '', point_name: '', point_kbn: '', apply_kbn: '' });
    const [listRefresh, setListRefresh] = useState(true);

    const { classes } = props;

    /**
     *
     * 詳細画面表示
     * （一覧画面から行選択された場合）
     *
     * @param data 選択された行のデータ
     */
    const showDetail = (data, merchantName, merchantType, pointName, pointKbn, applyKbn) => {
        // 選択された行のポイント情報を取得して、詳細画面を表示
        pointManagementActions.loadEditModel(token, data.point_rule_id)
            .then(data => {
                setModeInfo({ mode: 'detail', merchant_name: merchantName, merchant_type: merchantType, point_name: pointName, point_kbn: pointKbn, apply_kbn: applyKbn });
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 詳細画面表示
     * （編集画面から詳細画面に戻る場合）
     *
     */
    const showDetailBack = () => {
        // 詳細画面を再表示
        setModeInfo({ mode: 'detail', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, point_name: modeInfo.point_name, point_kbn: modeInfo.point_kbn, apply_kbn: modeInfo.apply_kbn });
    }

    /**
     *
     * リスト画面表示
     *
     */
    const showList = () => {
        setListRefresh(false);
        setModeInfo({ mode: 'list', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, point_name: modeInfo.point_name, point_kbn: modeInfo.point_kbn, apply_kbn: modeInfo.apply_kbn });
    }

    /**
     *
     * 編集画面表示
     *
     */
    const showEdit = () => {
        setModeInfo({ mode: 'edit', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, point_name: modeInfo.point_name, point_kbn: modeInfo.point_kbn, apply_kbn: modeInfo.apply_kbn });
    }

    /**
     *
     * 新規作成画面表示
     *
     */
    const showCreate = (merchantName, merchantType, pointName, pointKbn, applyKbn) => {
        pointManagementActions.loadEditModel(token, null)
            .then(data => {
                setModeInfo({ mode: 'create', merchant_name: merchantName, merchant_type: merchantType, point_name: pointName, point_kbn: pointKbn, apply_kbn: applyKbn });
            })
            .catch(e => {
                notificationActions.showError('新規データを作成できませんでした。');
            });
    }

    var listClass = classes.hiddenList;
    if (modeInfo.mode == 'list') {
        listClass = classes.visibleList;
    }

    var content = <div></div>;

    if (modeInfo.mode == 'create') {
        // 新規作成
        content = <PointManagementEdit onCancel={showList} createFlag={true} />
    }
    if (modeInfo.mode == 'detail') {
        // 詳細
        content = <PointManagementDetail onCancel={showList} onEdit={showEdit} />
    }
    if (modeInfo.mode == 'edit') {
        // 編集
        content = <PointManagementEdit onCancel={showDetailBack} createFlag={false} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <PointManagementList onCreate={showCreate} onDetail={showDetail} refresh={listRefresh}
                    merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} pointName={modeInfo.point_name} pointKbn={modeInfo.point_kbn} applyKbn={modeInfo.apply_kbn} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(PointManagement);
